import { PathEnum } from "core/routes/path.enum";

export const SIDEBAR_ITEMS: SidebarItem[] = [
	{ label: "CAA", route: PathEnum.ACTIVITIES },
	{ label: "Libreria", route: PathEnum.LIBRARY },
	{ label: "Libreria Immagini", route: PathEnum.IMAGE_LIBRARY },
	{ label: "Signs", route: PathEnum.SIGN },
	{ label: "User Manager", route: PathEnum.USER_MANAGER },
];

interface SidebarItem {
	label: string;

	route: string;
}
